<template>
  <div
    v-if="!elementAttributes.removed && componentKey > 0"
    :key="componentKey"
    :id="elementAttributes.id"
    :page="currentRoute"
    :userName="'admin'"
    :displayLang="lang"
    :pageSize="100"
    :keycloakToken="token"
    :routePrefix="'/' + $realm"
    :master="'AmrPortal'"
    :environment="'AmrPortal'"
    hasNavigation="false"
  ></div>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "root-element",
  inject: ["lang"],
  props: {
    elementAttributes: {
      type: Object,
      required: true,
    },
    route: {
      type: String,
      default: null,
    },
    entryPoint: {
      type: Object,
      default: null,
    },
    activeModule: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      componentKey: 1,
      currentRoute:
        this.route !== null ? this.route : this.elementAttributes.page,
    };
  },
  computed: {
    ...mapState(["token"]),
    isActive() {
      return (
        this.elementAttributes.id === this.activeModule && this.componentKey > 0
      );
    },
  },
  watch: {
    route() {
      if (this.elementAttributes.id === this.activeModule) {
        this.currentRoute = this.$route.href;
        if (this.elementAttributes.isReact) {
          this.componentKey = 0;
          setTimeout(() => {
            this.componentKey = 1;
          }, 5);
        }
      }
    },
    isActive(newVal) {
      if (newVal && this.elementAttributes.isReact) {
        setTimeout(() => {
          this.mountReactApp(this.currentRoute);
        }, 5);
      }
    },
  },
  methods: {
    mountReactApp(target) {
      window[`${this.elementAttributes.id}Mount`].mount(this.$el, {
        page: target, // TODO: will be removed
      });
    },
  },
});
</script>
